import { AnyAction } from 'redux';

import { MerchantsReceivedAction, MERCHANTS_RECEIVED } from '@ttstr/actions/merchants';
import { Articles, IndexedMerchants, Product } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  merchantsReceived: boolean;
  merchants: IndexedMerchants;
}

const initialState: ReduxState = {
  merchantsReceived: false,
  merchants: {},
};

const merchants = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case MERCHANTS_RECEIVED: {
      const { merchants } = (action as MerchantsReceivedAction).payload;

      if (!merchants) return state;

      return {
        ...state,
        merchantsReceived: true,
        merchants: merchants.reduce(
          (previous, current) => ({
            ...previous,
            [current.id]: current,
          }),
          {}
        ),
      };
    }
    default:
      return state;
  }
};

export const getMerchants = (state: AppState) => {
  return state.Merchants.merchants;
};

export const getMerchantsReceived = (state: AppState) => {
  return state.Merchants.merchantsReceived;
};

export const getMerchantFromProduct = (merchants: IndexedMerchants, product: Product) => {
  return merchants[product.merchant_id];
};

export const getMerchantsForProducts = (merchants: IndexedMerchants, products: Articles) => {
  if (!merchants) return {};
  return Object.entries(merchants).reduce<IndexedMerchants>(
    (acc, [id, merchant]) => (products.some((p) => p.merchant_id === Number(id)) ? { ...acc, [id]: merchant } : acc),
    {}
  );
};

export default merchants;
